<template>
  <div id="app" class="page">
    <LazyHydrate when-visible>
      <PageHeader
        ref="headerComponent"
        :items="menuItems"
        :route-item="routeMenuItem"
        :cart="cart"
        :site-message="siteMessage"
        :banner-message="bannerMessage"
        :cart-count="cartCount"
        :favorites-count="favoritesCount"
        :show-contact-banner="showContactBanner"
        :show-search-bar="showSearchBar"
        :enable-search-suggestions="enableSearchSuggestions"
        :show-mobile-category-menu="showMobileCategoryMenu"
        :search-query="searchQuery"
        :country="countryCode"
        :scroll-container="scrollContainer"
        :cart-fetched="cartFetched"
        @chat="chat"
        @search="search"
        @openCart="openMiniCart"
        @checkout="checkout"
        @changeCountry="changeCountry({ country: $event })"
        @closeBanner="closeBanner"
        @openMenu="openMenu"
        @closeMenu="closeMenu"
      ></PageHeader>
    </LazyHydrate>

    <div class="app-container-wrapper">
      <Breadcrumb v-if="mounted" />
      <div class="app-container">
        <slot></slot>
      </div>
    </div>

    <Newsletter v-if="$route.meta.newsletter" />

    <LazyHydrate when-visible>
      <PageFooter></PageFooter>
    </LazyHydrate>
  </div>
</template>
<script>
import LazyHydrate from '@/components/lazy/LazyHydrate.js';
import { MediaUtils } from '@article/pixel';
import {
  mapState, //
  mapGetters,
  mapActions,
  mapMutations,
} from 'vuex';
import CountryUtils from '@/components/commons/CountryUtils.js';
import PageHeader from '@/components/header/PageHeader.vue';
import Newsletter from '@/components/commons/Newsletter.vue';
import PageFooter from '@/components/footer/PageFooter.vue';
import Breadcrumb from '@/components/breadcrumb/Breadcrumb.vue';
import useFavorite from '@/compositions/useFavorite.js';

export default {
  components: {
    PageHeader,
    PageFooter,
    Breadcrumb,
    Newsletter,
    LazyHydrate,
  },

  setup() {
    const { favoritesCount } = useFavorite();

    return {
      favoritesCount,
    };
  },

  data() {
    return {
      scrollContainer: false,
      mounted: false,
    };
  },

  computed: {
    ...mapState('common', [
      'countryId',
      'menuItems',
      'showContactBanner',
      'showMobileCategoryMenu',
      'searchQuery',
      'enableSearchSuggestions',
      'sessionCart',
      'cartCount',
      'cart',
      'siteMessage',
      'notifyCartItemsAdded',
      'cartFetched',
    ]),

    ...mapGetters('common', ['routeMenuItem']),
    ...mapState('common', ['bannerMessage']),

    countryCode() {
      return CountryUtils.getCountryById(this.countryId).code;
    },

    showSearchBar() {
      const openSearchBarPages = ['/search'];
      const closedSearchBarPages = ['/product', '/cart', '/trade', '/business'];
      return (
        openSearchBarPages.some((page) => window.location.href.indexOf(page) > -1) ||
        (!closedSearchBarPages.some((page) => window.location.href.indexOf(page) > -1) && MediaUtils.isTabletAndSmaller)
      );
    },
  },

  watch: {
    notifyCartItemsAdded(newVal) {
      if (newVal && this.$refs && this.$refs.headerComponent) {
        this.$refs.headerComponent.notifyCartItemsAdded();
        this.updateNotifyCartItemsAdded(false);
      }
    },
  },

  mounted() {
    this.mounted = true;
  },

  methods: {
    ...mapActions('common', ['chat', 'search', 'openMiniCart', 'checkout', 'changeCountry', 'closeBanner']),

    ...mapMutations('common', ['updateNotifyCartItemsAdded']),

    openMenu() {
      if (MediaUtils.isMobileAndSmaller) {
        const html = document.querySelector('html');
        html.classList.add('overflow-hidden');
        html.classList.add('overflow-hidden-long');

        this.scrollContainer = true;
      }
    },

    closeMenu() {
      const html = document.querySelector('html');
      html.classList.remove('overflow-hidden');
      html.classList.remove('overflow-hidden-long');
      this.scrollContainer = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  display: flex;
  flex-flow: column;
  min-height: 100vh;

  .app-container-wrapper {
    display: flex;
    flex-flow: column;
    flex-grow: 2;

    .app-container {
      flex-grow: 2;
    }
  }
}
</style>
